"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Preloader = void 0;
var _reactLottiePlayer = require("@lottiefiles/react-lottie-player");
var _Preloader = require("./Preloader.styles");
var _loader = _interopRequireDefault(require("./resources/loader.json"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Preloader = props => {
  const {
    url
  } = props;
  const styles = (0, _Preloader.useStyles)(props);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-Preloader'],
    role: "marquee",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactLottiePlayer.Player, {
      autoplay: true,
      loop: true,
      controls: false,
      src: url ?? _loader.default
    })
  });
};
exports.Preloader = Preloader;